import {
  Box,
  Button,
  FileInput,
  Group,
  LoadingOverlay,
  Popover,
  Select,
  Text,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import "@mantine/dates/styles.css";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconFileCv, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import ImageShow from "../../../_base/component/_image";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import {
  formatDateToString,
  urlToImageFile,
} from "../../../_base/helper/FunctionHelper";
import Repository from "../../../_base/helper/HttpHelper";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblBrandCommand } from "../../../model/TblBrandCommand";
import { uploadImageAddFolder } from "../../../api/ApiMore";

const EditView = ({
  id,
  onClose,
  load,
}: {
  id: number;
  onClose: any;
  load: number;
}) => {
  const entity: TblBrandCommand = {
    id: 0,
    brandIndex: null,
    name: null,
    summary: null,
    image: null,
    product: null,
    status: null,
    isFeatured: null,
    ordering: null,
    letter: null,
    brandPageView: null,
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    metaTitle: null,
    metaKeywords: null,
    metaDescription: null,
    description: null,
    priorityStatus: null,
  };

  const form = useForm<TblBrandCommand>({
    initialValues: {
      ...entity,
    },

    validate: {
      name: hasLength({ min: 2, max: 100 }, "Tên phải chưa từ 2-100 kí tự !"),
      // brandIndex: (value: string | null) => {
      //   if (value && !/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(value)) {
      //     return "Link không hợp lệ!";
      //   }

      //   return undefined; // Trường hợp hợp lệ hoặc giá trị rỗng
      // },
      // image: (value) => {
      //   if (value) {
      //     if (value instanceof File) {
      //       const allowedExtensions = [".jpg", ".png"];
      //       const fileName = value.name.toLowerCase();

      //       if (!allowedExtensions.some((ext) => fileName.endsWith(ext))) {
      //         return "Logo phải có dạng .jpg hoặc .png";
      //       }
      //     }
      //   } else return "Chưa nhập logo thương hiệu";
      // },
      // letter: (value) => {
      //   if (value && value.length > 2) {
      //     return "Lời nhắn tối đa 2 ký tự";
      //   }
      // },
      // imageUrl: (value) => {
      //   if (!value) {
      //     return "Chưa có logo thương hiệu";
      //   }
      // },
      image: (value, values) => {
        // Nếu có dữ liệu thì bắt buộc phải có image
        if (values.name && !value) {
          return "Chưa nhập logo thương hiệu";
        }
      },
    },
  });

  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [isImageChange, setIsImageChange] = useState<boolean>(false);
  const [isContinue, setIsContinue] = useState(true);
  const [iconimage, setIconImage] = useState<string>("");
  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );
  const [popoverOpened, setPopoverOpened] = useState(false);
  const [nameImage, setNameImage] = useState<string>("");
  const [urlImageFolder, setUrlImageFolder] = useState<string>("");
  const [loadingImage, setLoadingImage] = useState<number>(0);

  const handleChangeImage = (file: File | null) => {
    form.getInputProps("image").onChange(file);
    setIsImageChange(true);
  };

  const callApiGetData = async () => {
    open();
    let urlCreate = API_ROUTE.DETAIL_BRAND + id;
    let callapi = await repository.post<MessageResponse<TblBrandCommand>>(
      urlCreate
    );
    if (!isNullOrUndefined(callapi) && !isNullOrUndefined(callapi?.data)) {
      const dataApi = callapi?.data;
      if (dataApi?.image) {
        setNameImage(String(dataApi.image));
      }
      if (dataApi?.imageUrl) {
        setUrlImageFolder(String(dataApi.imageUrl));
      }
      if (dataApi != null && !isNullOrUndefined(dataApi)) {
        if (
          dataApi.image !== null &&
          dataApi.image !== undefined &&
          typeof dataApi.image == "string"
        ) {
          setIconImage(dataApi.image);
          // Tạo một file với tên từ API để FileInput hiển thị
          const imageFile = await urlToImageFile(
            `${dataApi.imageUrl}/${dataApi.image}`
          );

          // Tạo file mới với tên gốc từ API
          if (imageFile) {
            const newFile = new File([imageFile], dataApi.image, {
              type: imageFile.type,
              lastModified: imageFile.lastModified,
            });
            dataApi.image = newFile;
          }
        }

        form.setValues(dataApi);
      }

      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };

  const handleUploadImage = async (files: File[] | File) => {
    if (!files) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    }

    const newDate = formatDateToString(new Date());
    const fileArray = Array.isArray(files) ? files : [files];

    if (fileArray.length === 0) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    } else {
      const res = await uploadImageAddFolder(
        `cdn/Media/Image/Brand/${newDate}`,
        fileArray
      );

      if (res && res.success) {
        const data = res?.data[0]?.url;
        const lastSlashIndex = data?.lastIndexOf("/");
        const baseUrl2 = data?.substring(0, lastSlashIndex);
        const fileName2 = data?.substring(lastSlashIndex + 1);

        NotificationExtension.Success("Tải ảnh lên thành công !");
        setNameImage(fileName2);
        setUrlImageFolder(baseUrl2);
        setLoadingImage((prev) => prev + 1);
      } else {
        NotificationExtension.Fails(res.message);
        form.setValues((prev) => ({
          ...prev,
          image: null,
          imageUrl: null,
        }));
        setNameImage("");
        setUrlImageFolder("");
      }
    }
  };

  const handleCreatePayment = async (data: TblBrandCommand) => {
    open();
    let dataEdit: any = {};
    const { image, ...restGroup } = data;
    if (isImageChange) {
      dataEdit = data;
    } else dataEdit = restGroup;
    let success = false;
    let urlCreate = API_ROUTE.MODIFY_BRAND;
    let callapi = await repository.put<MessageResponse<boolean>>(
      urlCreate,
      {
        ...dataEdit,
        isFeatured: dataEdit.priorityStatus == "A" ? "True" : "False",
        image: nameImage.length > 0 ? nameImage : null,
        imageUrl: urlImageFolder.length > 0 ? urlImageFolder : null,
      },
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    success = callapi?.success ?? false;
    if (!isNullOrUndefined(callapi) && callapi?.success) {
      if (isContinue)
        form.setValues({
          ...entity,
        });
      onClose(load + 1);
      NotificationExtension.Success("Sửa thành công !");
    } else if (callapi != null) NotificationExtension.Fails("Sửa thất bại !");
    close();
    if (!isContinue && success == true) modals.closeAll();
  };

  useEffect(() => {
    callApiGetData();
  }, [id]);

  useEffect(() => {
    if (isImageChange) {
      const files = form.getValues()?.image;
      if (files && files instanceof File) {
        handleUploadImage(files);
      } else if (!files) {
        // Reset state khi file bị xóa
        setNameImage("");
        setUrlImageFolder("");
      }
    }
  }, [form.getValues()?.image]);

  const formCreate = (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={1200}
        maw={1200}
        mx="auto"
        onSubmit={form.onSubmit((e: TblBrandCommand) => {
          handleCreatePayment(e);
        })}
      >
        <LoadingOverlay
          visible={false}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên thương hiệu"}
            placeholder={"Nhập tên"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("name")}
          />

          {/* <TextInput
            label={"Link Web"}
            placeholder={"Nhập link"}
            mt="md"
            type="text"
            {...form.getInputProps("brandIndex")}
          /> */}
        </Group>{" "}
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Thứ tự xuất hiện"}
            placeholder={"Nhập thứ tự"}
            mt="md"
            type="number"
            {...form.getInputProps("ordering")}
          />

          <Select
            label={"Nổi bật"}
            placeholder={"Chọn"}
            mt="md"
            data={[
              { value: "A", label: "Nổi bật" },
              { value: "I", label: "Không nổi bật" },
            ]}
            {...form.getInputProps("priorityStatus")}
          />

          <Select
            label={"Trạng thái"}
            placeholder={"Chọn trạng thái"}
            mt="md"
            // data={["Hoạt động", "Không hoạt động"]}
            data={[
              { value: "A", label: "Hoạt động" },
              { value: "I", label: "Không hoạt động" },
            ]}
            {...form.getInputProps("status")}
          />
        </Group>
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <FileInput
            leftSection={icon}
            label={"Logo thương hiệu"}
            placeholder={"Chọn logo"}
            accept="image/png,image/jpeg"
            withAsterisk
            clearable
            mt="md"
            value={form.getValues().image as File | null}
            onChange={handleChangeImage}
            valueComponent={({ value }) => {
              if (value instanceof File) {
                return <span>{value.name}</span>;
              }
              if (nameImage && !isImageChange) {
                return <span>{nameImage}</span>;
              }
              return null;
            }}
          />
          {nameImage.length > 0 && urlImageFolder.length > 0 ? (
            <ImageShow
              h={200}
              w={300}
              img={`${urlImageFolder}/${nameImage}`}
              loading={loadingImage}
            />
          ) : (
            <Box></Box>
          )}
        </Group>
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Textarea
            label={"Mô tả tóm tắt"}
            placeholder={"Nhập tóm tắt"}
            autosize
            minRows={3}
            mt="md"
            {...form.getInputProps("summary")}
          />
        </Group>{" "}
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Text fz={17} fw={700}>
            Dùng cho SEO
          </Text>
        </Group>
        <Group grow wrap="nowrap" gap={"lg"}>
          <TextInput
            label={"Tiêu đề"}
            placeholder={"Nhập tiêu đề"}
            mt="md"
            type="text"
            {...form.getInputProps("metaTitle")}
          />

          <TextInput
            label={"Từ khoá"}
            placeholder={"Nhập từ khoá"}
            mt="md"
            type="text"
            {...form.getInputProps("metaKeywords")}
          />
        </Group>
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Mô tả"}
            placeholder={"Nhập mô tả"}
            mt="md"
            type="text"
            {...form.getInputProps("metaDescription")}
          />
        </Group>
        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            onClick={() => {
              setIsContinue(false);
            }}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>

          <Popover
            width={300}
            position="top"
            withArrow
            shadow="md"
            opened={popoverOpened}
            onChange={setPopoverOpened}
          >
            <Button
              color="red"
              style={{ marginLeft: 10 }}
              onClick={() => modals.closeAll()}
              leftSection={<IconX size={18} />}
            >
              Đóng
            </Button>
          </Popover>
        </Group>
      </Box>
    </>
  );

  return <>{formCreate}</>;
};

export default EditView;
